<template>
  <div class="main-menu__footer">
    <!-- поиск в меню -->
    <transition name=scaleUp mode="out-in">
      <the-menu-search v-if="searchIsActive"/>
      <!-- /поиск в меню -->
      <!-- дополнительное меню -->
      <the-menu-additional-menu v-if="addMenuIsActive"/>
    </transition>
    <!-- дополнительное меню -->

    <!-- кнопки меню -->
    <the-menu-controls
      @search-toggle="searchToggle"
      @add-menu-toggle="addMenuToggle"
      @log-out="logOut"
    />
    <!-- /кнопки меню -->
  </div>
</template>

<script>
import TheMenuControls from './TheMenuControls.vue'
import TheMenuSearch from './TheMenuSearch.vue'
import TheMenuAdditionalMenu from './TheMenuAdditionalMenu.vue'

export default {
  name: 'AppMenuFooter',
  components: {
    TheMenuControls,
    TheMenuSearch,
    TheMenuAdditionalMenu
  },
  data () {
    return {
      searchIsActive: false,
      addMenuIsActive: false
    }
  },
  methods: {
    searchToggle () {
      this.searchIsActive = !this.searchIsActive
      this.addMenuIsActive = false
    },
    addMenuToggle () {
      this.addMenuIsActive = !this.addMenuIsActive
      this.searchIsActive = false
    },
    logOut () {
      this.$emit('log-out')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../assets/css/system/_vars';
  @import '../../assets/css/system/_mixins';

    .scaleUp-enter-active {
        transform-origin: bottom;
        animation: scale-up .3s;
    }
    .scaleUp-leave-active {
        transform-origin: bottom;
        animation: scale-up .3s reverse;
    }

    @keyframes scale-up {
        0% {
            transform: scaleY(0);
        }
        100% {
            transform: scaleY(1);
        }
    }
</style>
